import React from "react";

function Footer() {
  return (
    <footer className="bg-dark pb-4">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div>
              <p className="text-muted mt-4 text-center mb-0">
                © 2023 - Developed by Soo Hwangbo
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
